import { render, staticRenderFns } from "./PageRoles.vue?vue&type=template&id=f4c3acb0&"
import script from "./PageRoles.vue?vue&type=script&lang=js&"
export * from "./PageRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c3acb0')) {
      api.createRecord('f4c3acb0', component.options)
    } else {
      api.reload('f4c3acb0', component.options)
    }
    module.hot.accept("./PageRoles.vue?vue&type=template&id=f4c3acb0&", function () {
      api.rerender('f4c3acb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/roles/PageRoles.vue"
export default component.exports